module.exports = __webpack_public_path__ + "static/media/landing-img-bg.49d02519.jpg";